/**
 * Converts a string into a handle.
 * @param {string} str - The string to be converted.
 * @returns {string}
 */
(function () {
function handleize(str) {
  if (!str) return null;
  let result = str.slice().trim().toLowerCase();
  result = result.replace(/['"()[\]]/g, '');
  result = result.replace(/[^\p{L}\p{N}]+/gu, '-');
  result = result.replace(/-+$/, '');
  result = result.replace(/^-+/, '');
  return result;
}

if (!customElements.get('quiz-component')) {
  class QuizComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.setAttribute('loading', '');
      this.currentScreenIndex = 0;
      this.activeRoutine = 'day';

      this.form = this.querySelector('.quiz__form');
      this.screens = Array.from(this.querySelectorAll('.quiz__screen'));
      this.results = this.querySelector('.js-results');
      this.nextBtns = Array.from(this.querySelectorAll('[name="next"]'));
      this.previousBtn = this.querySelector('[name="previous"]');
      this.submitBtn = this.querySelector('[type="submit"]');
      this.retryBtn = this.querySelector('[name="retry"]');

      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.form.addEventListener('change', this.handleChange.bind(this));
      this.nextBtns.forEach((nextBtn) => {
        nextBtn.addEventListener('click', this.handleNext.bind(this));
      });
      this.previousBtn.addEventListener('click', this.handlePrevious.bind(this));
      this.retryBtn.addEventListener('click', this.handleRetry.bind(this));

      this.initWidget();
      this.render(false);
      this.removeAttribute('loading');
      this.setAttribute('loaded', '');
    }

    get action() {
      return this.form.action.split('?')[0];
    }

    get currentScreen() {
      return this.currentScreenIndex;
    }

    set currentScreen(value = 0) {
      const min = 0;
      const max = (this.screens.length - 1);
      const to = Math.max(min, Math.min(value, max));
      if (this.currentScreenIndex === to) return;
      this.currentScreenIndex = to;
      this.render();
    }

    get prevEnabled() {
      return this.currentScreen > 0;
    }

    get nextEnabled() {
      const isLastScreen = this.currentScreen >= (this.screens.length - 1);
      const currentScreenElement = this.screens[this.currentScreen];
      const currentScreenHasInput = Boolean(
        currentScreenElement.querySelector('[type="checkbox"], [type="radio"]')
      );
      const currentScreenHasSelection = Boolean(
        currentScreenElement.querySelector('[type="checkbox"]:checked, [type="radio"]:checked')
      );
      return !isLastScreen && (currentScreenHasInput ? currentScreenHasSelection : true);
    }

    get submitEnabled() {
      let allAnswered = true;
      this.screens
        .filter((screen) => screen.querySelector('[type="checkbox"], [type="radio"]'))
        .forEach((screen) => {
          if (!screen.querySelector('[type="checkbox"]:checked, [type="radio"]:checked')) {
            allAnswered = false;
          }
        });
      return allAnswered;
    }

    async handleSubmit(event) {
      event.preventDefault();

      try {
        // UI: loading state
        this.previousBtn.disabled = true;
        this.submitBtn.disabled = true;
        if (!this.submitBtn.querySelector('.btn__loader')) {
          const btnLoader = document.createElement('div');
          btnLoader.classList.add('btn__loader');
          btnLoader.innerHTML = '<span></span><span></span><span></span>';
          this.submitBtn.appendChild(btnLoader);
        }
        this.submitBtn.setAttribute('loading', true);
        this.results.innerHTML = '';

        // -------------------------------------------------------
        // STEP 1: Collect one tag per question (in order)
        // -------------------------------------------------------
        const questionScreens = this.screens.filter((screen) =>
          screen.querySelector('[type="checkbox"], [type="radio"]')
        );

        const tagPerQuestion = [];
        questionScreens.forEach((screen) => {
          const checked = screen.querySelector('[type="checkbox"]:checked, [type="radio"]:checked');
          if (checked) {
            let tag = handleize(checked.value.split(',')[0].trim());
            if (tag.startsWith('day-')) tag = tag.slice(4);
            else if (tag.startsWith('night-')) tag = tag.slice(6);
            tagPerQuestion.push(tag);
          }
        });

        if (tagPerQuestion.length < questionScreens.length) {
          throw new Error('Not all questions answered.');
        }

        // -------------------------------------------------------
        // STEP 2: Build combined tag
        // handleize converts _ to - so product tag format is:
        // "day-blue-eyes-hair-grey-skin-fair-undertone-cool"
        // -------------------------------------------------------
        const combinedTag = tagPerQuestion.join('-');
        const dayCombinedTag = `day-${combinedTag}`;
        const nightCombinedTag = `night-${combinedTag}`;

        console.log('[QUIZ] Looking for day tag:', dayCombinedTag);
        console.log('[QUIZ] Looking for night tag:', nightCombinedTag);

        // -------------------------------------------------------
        // STEP 3: Fetch all products from collection JSON
        // -------------------------------------------------------
        const collectionHandle = this.action.split('/collections/')[1] || 'all';

        let page = 1;
        let allProducts = [];
        let hasMore = true;

        while (hasMore) {
          const url = `/collections/${collectionHandle}/products.json?limit=250&page=${page}`;
          // eslint-disable-next-line no-await-in-loop
          const res = await fetch(url);
          if (!res.ok) break;
          // eslint-disable-next-line no-await-in-loop
          const data = await res.json();
          const batch = data.products || [];
          allProducts = allProducts.concat(batch);
          hasMore = batch.length === 250;
          page++;
        }

        // -------------------------------------------------------
        // STEP 4: Filter products by combined tag
        // -------------------------------------------------------
        const dayProducts = allProducts.filter((product) => {
          const tags = product.tags.map((t) => t.trim().toLowerCase());
          return tags.includes(dayCombinedTag);
        });

        const nightProducts = allProducts.filter((product) => {
          const tags = product.tags.map((t) => t.trim().toLowerCase());
          return tags.includes(nightCombinedTag);
        });

        console.log('[QUIZ] Day products matched:', dayProducts.map((p) => p.handle));
        console.log('[QUIZ] Night products matched:', nightProducts.map((p) => p.handle));

        if (!dayProducts.length && !nightProducts.length) {
          throw new Error(`No products found with tags: "${dayCombinedTag}" or "${nightCombinedTag}"`);
        }

        // -------------------------------------------------------
        // STEP 5: Fetch product cards by paginating collection HTML
        // -------------------------------------------------------
        const getCardForProduct = async (product) => {
          let p = 1;
          while (p <= 10) {
            // eslint-disable-next-line no-await-in-loop
            const res = await fetch(`/collections/${collectionHandle}?page=${p}`);
            if (!res.ok) break;
            // eslint-disable-next-line no-await-in-loop
            const html = await res.text();
            const dom = new DOMParser().parseFromString(html, 'text/html');
            const card = dom.querySelector(`product-card[data-product-id="${product.id}"]`);
            if (card) return card;
            const hasNext = dom.querySelector('a[href*="page="]');
            if (!hasNext) break;
            p++;
          }
          console.warn('[QUIZ] Card not found for:', product.handle, product.id);
          return null;
        };

        const [dayCards, nightCards] = await Promise.all([
          Promise.all(dayProducts.map(getCardForProduct)).then((r) => r.filter(Boolean)),
          Promise.all(nightProducts.map(getCardForProduct)).then((r) => r.filter(Boolean)),
        ]);

        if (!dayCards.length && !nightCards.length) throw new Error('Could not render product cards.');

        // -------------------------------------------------------
        // STEP 6: Render results (with day/night tabs)
        // -------------------------------------------------------
        const template = this.querySelector('template');
        const templateUl = template.content.querySelector('ul');
        const hasCutoutCards = templateUl.classList.contains('has-cutout-cards');
        const hasImageBlending = templateUl.classList.contains('has-image-blending');

        const renderSection = (heading, cards, routine) => {
          if (!cards.length) return;

          const h2 = document.createElement('h2');
          h2.className = 'quiz__results-heading';
          h2.textContent = heading;
          this.results.appendChild(h2);

          const grid = templateUl.cloneNode(true);
          grid.innerHTML = '';
          grid.classList.add('quiz__results-grid');
          grid.dataset.routine = routine;

          // cards.forEach((card) => {
          //   const cardClone = card.cloneNode(true);
          //   const media = cardClone.querySelector('.media');
          //   if (media) {
          //     if (hasImageBlending && !hasCutoutCards) media.classList.add('image-blend');
          //     else media.classList.remove('image-blend');
          //   }
          //   const li = document.createElement('li');
          //   li.appendChild(cardClone);
          //   grid.appendChild(li);
          // });

          cards.forEach((card) => {
  const cardClone = card.cloneNode(true);

  
  // cardClone ITSELF is the <product-card>
  const productId = cardClone.dataset.productId;

  console.log('[QUIZ] Product card:', productId);

  const productData = [...dayProducts, ...nightProducts].find(
    (product) => String(product.id) === String(productId)
  );

  console.log('[QUIZ] Product data:', productData);

  if (productData) {
    // Get first available variant
    const variant =
      productData.variants.find((v) => v.available) ||
      productData.variants[0];

    console.log('[QUIZ] Variant:', variant);

    if (variant && variant.available) {
      cardClone.dataset.quizVariantId = variant.id;
    }

    const quickAddContainer =
      cardClone.querySelector('.card__quick-add');

    console.log(
      '[QUIZ] Quick add container:',
      quickAddContainer
    );

    if (quickAddContainer && variant) {

      // Completely remove the existing Quick Shop markup
      quickAddContainer.innerHTML = '';

      // Create normal Add to Cart button
      const addButton = document.createElement('button');

      addButton.type = 'button';
      addButton.className =
        'btn quick-add-btn btn--secondary quiz-product-add-to-cart';

      addButton.dataset.variantId = variant.id;

      if (!variant.available) {
        addButton.disabled = true;
      }

      addButton.innerHTML = `
        <span class="quick-add-btn-text pointer-events-none">
          ${variant.available ? 'ADD TO CART' : 'SOLD OUT'}
        </span>

        <span class="quick-add-btn-icon pointer-events-none">
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            aria-hidden="true"
          >
            <path
              d="M5 12h14M13 6l6 6-6 6"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>
      `;

      quickAddContainer.appendChild(addButton);

      // ---------------------------------------------------
      // ADD TO CART
      // ---------------------------------------------------

      if (variant.available) {
        addButton.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (addButton.disabled) return;

          addButton.disabled = true;

          const buttonText =
            addButton.querySelector('.quick-add-btn-text');

          if (buttonText) {
            buttonText.textContent = 'ADDING...';
          }

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variant.id),
                    quantity: 1
                  }
                ]
              })
            });

            if (!response.ok) {
              throw new Error('Failed to add product to cart');
            }

            // Refresh cart data
            await fetch('/cart.js', {
              cache: 'no-store'
            });

            // Refresh cart drawer
            document.dispatchEvent(
              new CustomEvent(
                'dispatch:cart-drawer:refresh',
                {
                  bubbles: true
                }
              )
            );

            // Give drawer time to refresh
            await new Promise((resolve) =>
              setTimeout(resolve, 250)
            );

            // Open cart drawer
            document.dispatchEvent(
              new CustomEvent(
                'dispatch:cart-drawer:open',
                {
                  bubbles: true,
                  detail: {
                    opener: addButton
                  }
                }
              )
            );

            if (buttonText) {
              buttonText.textContent = 'ADDED';
            }

            setTimeout(() => {
              if (buttonText) {
                buttonText.textContent = 'ADD TO CART';
              }

              addButton.disabled = false;
            }, 1200);

          } catch (error) {
            console.warn(
              '[QUIZ] Add to cart failed:',
              error
            );

            if (buttonText) {
              buttonText.textContent = 'ADD TO CART';
            }

            addButton.disabled = false;
          }
        });
      }
    }
  }

  // =====================================================
  // EXISTING IMAGE BEHAVIOR
  // =====================================================

  const media = cardClone.querySelector('.media');

  if (media) {
    if (hasImageBlending && !hasCutoutCards) {
      media.classList.add('image-blend');
    } else {
      media.classList.remove('image-blend');
    }
  }

  // =====================================================
  // ADD CARD TO GRID
  // =====================================================

  const li = document.createElement('li');

  li.appendChild(cardClone);

  grid.appendChild(li);
});

          this.results.appendChild(grid);
        };

        renderSection('Day Routine', dayCards, 'day');
        renderSection('Night Routine', nightCards, 'night');

        // Default active tab: whichever routine actually has results
        this.activeRoutine = dayCards.length ? 'day' : 'night';

        const dayText = document.getElementById('quiz-day-text');
const nightText = document.getElementById('quiz-night-text');

if(dayText && nightText){
    dayText.style.display = this.activeRoutine === 'day' ? '' : 'none';
    nightText.style.display = this.activeRoutine === 'night' ? '' : 'none';
}

        this.initResultTabs();
        this.initAddAllButton();

        this.currentScreen = (this.currentScreen + 1);
      } catch (error) {
        console.warn('[QUIZ] Error:', error.message);
        const template = this.querySelector('template');
        const noResults = template.content.querySelector('div').cloneNode(true);
        this.results.appendChild(noResults);
        this.currentScreen = (this.currentScreen + 1);
      } finally {
        this.previousBtn.disabled = false;
        this.submitBtn.disabled = false;
        this.submitBtn.removeAttribute('loading');
      }
    }

    // -------------------------------------------------------
    // Day / Night results tabs
    // -------------------------------------------------------
    initResultTabs() {
      const { results } = this;
      if (!results) return;
      if (results.querySelector('.quiz-results-tabs')) return;

      const headings = results.querySelectorAll('.quiz__results-heading');
      // Only show tabs when BOTH day and night results exist.
      if (headings.length < 2) return;

      const dayHeading = headings[0];
      const nightHeading = headings[1];
      const dayGrid = dayHeading.nextElementSibling;
      const nightGrid = nightHeading.nextElementSibling;

      const tabs = document.createElement('div');
      tabs.className = 'quiz-results-tabs';
      tabs.innerHTML = `
        <button type="button" class="quiz-results-tab active" data-tab="day">Day Look</button>
        <button type="button" class="quiz-results-tab" data-tab="night">Night Look</button>
      `;
      results.prepend(tabs);

      dayHeading.style.display = 'none';
      nightHeading.style.display = 'none';
      dayGrid.style.display = '';
      nightGrid.style.display = 'none';

      const summaryTitle = this.querySelector('#quiz-summary-title') || document.getElementById('quiz-summary-title');

      tabs.addEventListener('click', (event) => {
        const button = event.target.closest('.quiz-results-tab');
        if (!button) return;

        tabs.querySelectorAll('.quiz-results-tab').forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');

        this.activeRoutine = button.dataset.tab;

        const dayText = document.getElementById('quiz-day-text');
        const nightText = document.getElementById('quiz-night-text');

        const dayImage = document.getElementById('quiz-day-image');
        const nightImage = document.getElementById('quiz-night-image');

        if (this.activeRoutine === 'day') {
          if (summaryTitle) summaryTitle.textContent = 'Your Day Look';
          dayGrid.style.display = '';
          nightGrid.style.display = 'none';
          if(dayText) dayText.style.display = '';
    if(nightText) nightText.style.display = 'none';
    if(dayImage) dayImage.style.display = '';
    if(nightImage) nightImage.style.display = 'none';
        } else {
          if (summaryTitle) summaryTitle.textContent = 'Your Night Look';
          dayGrid.style.display = 'none';
          nightGrid.style.display = '';
           if(dayText) dayText.style.display = 'none';
    if(nightText) nightText.style.display = '';

    if(dayImage) dayImage.style.display = 'none';
    if(nightImage) nightImage.style.display = '';
        }

        this.updateAddAllLabel();
      });
    }

    // -------------------------------------------------------
    // Add-all-to-bag button (adds only the active tab's items)
    // -------------------------------------------------------
    initAddAllButton() {
      const addAllBtn = this.querySelector('#quiz-add-all') || document.getElementById('quiz-add-all');
      if (!addAllBtn) return;

      this.addAllBtn = addAllBtn;
      addAllBtn.style.display = 'block';
      this.updateAddAllLabel();

            addAllBtn.onclick = async () => {
        const activeGrid = this.results.querySelector(
          `.quiz__results-grid[data-routine="${this.activeRoutine}"]`
        );

        if (!activeGrid) {
          alert('No products found');
          return;
        }

        const seen = new Set();
        const items = [];

        // Preferred: ids stored on the cards (survive the quick-add replacement)
        activeGrid.querySelectorAll('[data-quiz-variant-id]').forEach((card) => {
          const id = Number(card.dataset.quizVariantId);
          if (id && !seen.has(id)) { seen.add(id); items.push({ id, quantity: 1 }); }
        });

        // Fallback: hidden form inputs, if a card still has one
        if (!items.length) {
          activeGrid.querySelectorAll('input[name="id"]').forEach((input) => {
            const id = Number(input.value);
            if (id && !seen.has(id)) { seen.add(id); items.push({ id, quantity: 1 }); }
          });
        }

        if (!items.length) {
          alert('No products found');
          return;
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });
          

          if (!response.ok) throw new Error('Failed to add products to cart');

          // Wait until Shopify finishes updating the cart
            await fetch('/cart.js', {
          cache: 'no-store'
         });

        // Small delay to ensure the cart sections are ready
          await new Promise(resolve => setTimeout(resolve, 250));

          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));

          // Wait for the drawer HTML to be replaced
         await new Promise(resolve => setTimeout(resolve, 250));
          
          document.dispatchEvent(
            new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: addAllBtn } })
          );

          
        } catch (err) {
          console.warn('[QUIZ] Add to cart failed:', err);
          alert('Something went wrong adding these products to your bag.');
        }
      };
    }

    // updateAddAllLabel() {
    //   if (!this.addAllBtn) return;
    //   this.addAllBtn.textContent =
    //     this.activeRoutine === 'day' ? 'Add Day Routine To Bag' : 'Add Night Routine To Bag';
    // }

     updateAddAllLabel() {
       if (!this.addAllBtn) return;
      const data =
  this.activeRoutine === 'day'
    ? {
        title: 'ADD DAY LOOK TO BAG',
        code: 'DAY BUNDLE',
        worth: '$120',
        price: '$96'
      }
    : {
        title: 'ADD NIGHT LOOK TO BAG',
        code: 'NIGHT BUNDLE',
        worth: '$111',
        price: '$89'
      };

this.addAllBtn.innerHTML = `
  <div class="quiz-add-btn-inner">
      <div class="quiz-add-btn-title">${data.title}</div>
      <div class="quiz-add-btn-subtitle">
      Use code <strong>${data.code}</strong> to get products worth
      <span class="quiz-old-price">${data.worth}</span>
      at
      <span class="quiz-new-price">${data.price}</span>
    </div>
  </div>
`;
     }

    

    handleChange() {
      this.renderButtons();
    }

    handleNext(event) {
      event.preventDefault();
      this.currentScreen = (this.currentScreen + 1);
    }

    handlePrevious(event) {
      event.preventDefault();
      this.currentScreen = (this.currentScreen - 1);
    }

    handleRetry(event) {
      event.preventDefault();
      this.screens
        .filter((screen) => screen.querySelector('[type="checkbox"], [type="radio"]'))
        .forEach((screen) => {
          screen.querySelectorAll('[type="checkbox"]:checked, [type="radio"]:checked').forEach((input) => {
            input.checked = false;
          });
        });
      this.results.innerHTML = '';
      this.currentScreen = 0;
    }

    render(scrollIntoView = true) {
      this.renderScreen();
      this.renderButtons();
      this.updateQuizProgress();
      if (scrollIntoView) this.scrollIntoView();
    }

    scrollIntoView() {
      const announcementHeight = parseInt(document.documentElement.style.getPropertyValue('--announcement-height'), 10) || 0;
      const headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'), 10) || 0;
      const targetPosition = Math.round(
        this.getBoundingClientRect().top + window.scrollY - (headerHeight - announcementHeight)
      ) || 0;
      if (Math.round(window.scrollY) > announcementHeight) {
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    }

    renderScreen() {
      this.screens.forEach((screen, index) => {
        if (index === this.currentScreen) {
          screen.classList.add('is-visible');
        } else {
          screen.classList.remove('is-visible');
        }
      });
    }

    renderButtons() {
      this.nextBtns.forEach((nextBtn) => {
        nextBtn.disabled = !this.nextEnabled;
      });
      this.previousBtn.disabled = !this.prevEnabled;
      this.submitBtn.disabled = !this.submitEnabled;
    }

    // Scoped to this component instance so multiple quizzes on
    // the same page don't clobber each other's progress bars.
    updateQuizProgress() {
      const questions = this.querySelectorAll('.quiz__question');
      const activeQuestion = this.querySelector('.quiz__question.is-visible');
      if (!activeQuestion || !questions.length) return;

      const current = Array.from(questions).indexOf(activeQuestion) + 1;
      const total = questions.length;

      const currentEl = activeQuestion.querySelector('.quiz-progress__current');
      const totalEl = activeQuestion.querySelector('.quiz-progress__total');
      const fillEl = activeQuestion.querySelector('.quiz-progress__fill');

      if (currentEl) currentEl.textContent = String(current).padStart(2, '0');
      if (totalEl) totalEl.textContent = String(total).padStart(2, '0');
      if (fillEl) fillEl.style.width = `${(current / total) * 100}%`;
    }

    initWidget() {
      const screen = this.screens.find((s) => s.classList.contains('quiz__personalize'));
      if (!screen) return;

      const input = screen.querySelector('input[name="name"]');
      if (!input) return;

      this.name = input.value.trim();

      const caption = screen.querySelector('figcaption');
      const nameElements = Array.from(this.querySelectorAll('.js-name'));
      const regex = /\[name\]/gi;

      nameElements.forEach((el) => {
        if (!el.dataset.default) el.dataset.default = el.textContent;
      });

      const updateElements = () => {
        if (caption) {
          caption.textContent = (this.name === '' && caption.dataset.default) ? caption.dataset.default : this.name;
        }
        nameElements.forEach((element) => {
          if (element.dataset.default) {
            const newText = element.dataset.default.replace(regex, this.name).replace(/\s+([.,!?;:])/g, '$1');
            if (element.textContent !== newText) element.textContent = newText;
          }
        });
      };

      updateElements();

      input.addEventListener('input', () => {
        this.name = input.value.trim();
        updateElements();
      });
    }
  }

  customElements.define('quiz-component', QuizComponent);
}
})();